import {
  processVariable,
  buildWhatsAppProcessedParams,
  findComponentByType,
  MEDIA_FORMATS,
} from '@chatwoot/utils';

// Constants and pure template helpers are shared with the mobile app via
// @chatwoot/utils so the logic lives in one place.
export {
  MEDIA_FORMATS,
  COMPONENT_TYPES,
  findComponentByType,
  processVariable,
  renderTemplatePreview,
} from '@chatwoot/utils';

export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_CATEGORY = 'UTILITY';

export const allKeysRequired = value => {
  const keys = Object.keys(value);
  return keys.every(key => value[key]);
};

export const replaceTemplateVariables = (templateText, processedParams) => {
  return templateText.replace(/{{([^}]+)}}/g, (match, variable) => {
    const variableKey = processVariable(variable);
    return processedParams.body?.[variableKey] || `{{${variable}}}`;
  });
};

export const getTemplateMediaUrl = template => {
  if (
    typeof template.status !== 'string' ||
    template.status.toLowerCase() !== 'approved'
  )
    return '';
  const header = findComponentByType(template, 'HEADER');
  if (!MEDIA_FORMATS.includes(header?.format)) return '';
  const handles = header.example?.header_handle;
  if (!Array.isArray(handles)) return '';
  const mediaUrl = handles[0];
  if (typeof mediaUrl !== 'string') return '';
  try {
    const url = new URL(mediaUrl);
    return url.protocol === 'https:' && !url.username && !url.password
      ? mediaUrl
      : '';
  } catch {
    return '';
  }
};

// The media-header flag is derived from the template inside the shared helper;
// the second argument is kept for backwards-compatible call sites.
export const buildTemplateParameters = template => {
  const parameters = buildWhatsAppProcessedParams(template);
  if (parameters.header?.media_type) {
    parameters.header.media_url = getTemplateMediaUrl(template);
  }
  return parameters;
};
